<template>
    <span
      v-if="!isPremium"
      class="badge badge-sm badge-warning p-1 px-2 ml-2 clickable"
      @click="withPremium"
    >
      <font-awesome-icon icon="crown" class="mr-1" />
      <slot>Premium Feature</slot>
    </span>
  </template>
  
  <script>
  export default {
    computed: {
      isPremium() {
        return this.$store.getters['billing/isPremium']
      },
    },
  }
  </script>